import React from 'react'
import { useLocation } from 'react-router-dom'
import { ExplorerProvider } from '../../../context/explorer'
import { ExplorerContent } from './ExplorerContent'
import styles from './ExplorerV2.module.scss'

/**
 * Main ExplorerV2 component.
 * Wraps content with ExplorerProvider to provide context.
 *
 * ExplorerContent is in a separate file because useExplorer() can only
 * be called inside a component that is a child of ExplorerProvider.
 */
export const ExplorerV2 = () => {
    const { state } = useLocation()

    return (
        <ExplorerProvider initialConfig={state?.editmodeConfig}>
            <div className={styles.explorerContainer}>
                <ExplorerContent />
            </div>
        </ExplorerProvider>
    )
}
